/* global gtag */
/**
 * Interact with the User API.
 */
import qs from 'qs';
import store from '../store/store';
import axios from '../axios-config';

const User = {
  guid: null,
  token: null,
  email: null,
  endpoints: {
    authenticateUser: '/users/token',
    updatePassword: null, // TODO: Create getter to return `/users/${this.guid}/reset-password`
    authenticatePasswordToken: null, // TODO: Create getter to return ``/users/${this.guid}/reset-password?code=${this.token}`
    requestPasswordToken: '/users/forgot-password',
    init: '/users/user-info', // Get user info, like username, agency name, accessible products
  },
  init() {
    return axios.get(
      this.endpoints.init,
    ).then((response) => {
      store.dispatch('updateUserData', response.data); // Store current user data
      sessionStorage.setItem('userFirstName', response.data.User.FirstName);
      sessionStorage.setItem('userLastName', response.data.User.LastName);
      return store.getters.user;
    }).catch((error) => {
      store.dispatch('updateUserData', {}); // Store current user data (it will use defaults within)

      window.console.warn('User has failed to get accessibleProducts.');
      gtag('event', 'exception', {
        description: 'Failed to get user accessibleProducts',
        fatal: false, // set to true if the error is fatal
      });

      return Promise.reject(error);
    });
  },
  /**
   * Receives all product options, and removes ones that are not accessible to the current user.
   *
   * @param {Array} products Product options that have an `internal_value` property
   */
  accessibleProducts(products) {
    const user = store.getters.user;

    // Remove products that are not in the current user's list of accessible products
    return products.filter(product => user.productAccess.indexOf(product.internal_value) !== -1);
  },
  requestPasswordToken(email, subdomain) {
    this.email = email; // The `email` is part of the payload of the `requestPasswordToken`
    const sub = subdomain || 'QRP';

    return axios.post(
      '/users/forgot-password', {
        email: this.email,
        agencySubdomain: sub,
      },
    ).then(() => true).catch((error) => {
      // TODO: Use response (data or http code) to evaluate error

      window.console.warn('An error occurred while resetting the user password:', error);
      gtag('event', 'exception', {
        description: 'Error resetting user password',
        fatal: false, // set to true if the error is fatal
      });

      return Promise.reject(error);
    });
  },
  updatePassword(guid, password, passwordConfirm, token) {
    this.guid = guid; // The `guid` is part of the URI of the User object

    this.endpoints.updatePassword = `/users/${this.guid}/reset-password`;

    return axios.post(
      this.endpoints.updatePassword, {
        Password: password,
        ConfirmPassword: passwordConfirm,
        Code: token,
      },
    ).then(() => {
      // TODO: Use response (data or http code) to evaluate whether it is a valid account
      store.dispatch('setPasswordUpdateSuccess', true);
    }).catch((error) => {
      // TODO: Use response (data or http code) to evaluate error
      window.console.warn('An error occurred while updating the user password:', error);
      gtag('event', 'exception', {
        description: 'Failed update user password',
        fatal: false, // set to true if the error is fatal
      });

      return Promise.reject(error);
    });
  },
  authenticateUser(username, password) {
    const params = {
      grant_type: 'password',
      username,
      password,
    };

    return axios({
      method: 'POST',
      url: this.endpoints.authenticateUser,
      data: qs.stringify(params),
    }).then((response) => {
      store.dispatch('updateUserData', response.data); // Store current user data

      /**
       * Set logged in user details into browser session storage
       */
      sessionStorage.setItem('refresh_token', response.data.refresh_token);
      sessionStorage.setItem('accessToken', response.data.access_token);
      sessionStorage.setItem('expires_at', response.data['.expires'] * 1000); // Time access token expires, in milliseconds

      sessionStorage.setItem('userAgency', response.data.agency);
      sessionStorage.setItem('tokenType', response.data.token_type);
      sessionStorage.setItem('permissions', response.data.permissions);
      sessionStorage.setItem('agencyId', response.data.agencyId);
      sessionStorage.setItem('userId', response.data.userId);
      sessionStorage.setItem('username', response.data.username);
      store.dispatch('login', response);
    }).catch((error) => {
      window.console.warn(`User ${username} has failed to authenticate.`);
      gtag('event', 'exception', {
        description: 'Failed to authenticate user',
        fatal: false, // set to true if the error is fatal
      });

      return Promise.reject(error);
    });
  },
  authenticatePasswordToken(guid, token) {
    this.guid = guid; // The `guid` is part of the URI of the User object
    this.token = token; // The `token` is part of the URI of the User object

    this.endpoints.authenticatePasswordToken = `/users/${this.guid}/reset-password?code=${this.token}`;

    return axios.get(this.endpoints.authenticatePasswordToken)
      .then(() => true)
      .catch(() => false);
  },
};
/**
 * export service to used by different components
 */
export default User;



// WEBPACK FOOTER //
// ./src/services/User.js